import {
  FOUNTAINS_ICON,
  ELECTRICAL_INSTALLATIONS_ICON,
  ASRTP_ICON,
  MEASUREMENT_REGULATION_ICON,
  SERVICE_ICON,
  INDUSTRY_ICON,
} from "@/components/icons/icons";
import { ImagesEnum } from "@/model/enum/ImagesEnum";
import { RoutesEnum } from "@/model/enum/RoutesEnum";
import { SolutionTypeEnum } from "@/model/enum/SolutionTypeEnum";

export const fontany = {
  nameKey: "solutions:fontany.name",
  descriptionKey: "solutions:fontany.description",
  href: `${RoutesEnum.SOLUTIONS}/${SolutionTypeEnum.FONTANY}`,
  icon: FOUNTAINS_ICON,
  imageUrl: ImagesEnum.DRUZBA_8,
  type: SolutionTypeEnum.FONTANY,

  detailsPageHeroDescriptionKey: "solutions:fontany.detailsPageHeroDescription",
  experienceKey: "solutions:fontany.experience",
  experiencePointsKey: "solutions:fontany.experiencePoints",
  ourFocusDescriptionKey: "solutions:fontany.ourFocusDescription",
  ourFocusPoints: [
    {
      icon: ELECTRICAL_INSTALLATIONS_ICON,
      titleKey: "solutions:fontany.ourFocusPoints.0.title",
      descriptionKey: "solutions:fontany.ourFocusPoints.0.description",
    },
    {
      icon: INDUSTRY_ICON,
      titleKey: "solutions:fontany.ourFocusPoints.1.title",
      descriptionKey: "solutions:fontany.ourFocusPoints.1.description",
    },
    {
      icon: ASRTP_ICON,
      titleKey: "solutions:fontany.ourFocusPoints.2.title",
      descriptionKey: "solutions:fontany.ourFocusPoints.2.description",
    },
    {
      icon: MEASUREMENT_REGULATION_ICON,
      titleKey: "solutions:fontany.ourFocusPoints.3.title",
      descriptionKey: "solutions:fontany.ourFocusPoints.3.description",
    },
    {
      icon: SERVICE_ICON,
      titleKey: "solutions:fontany.ourFocusPoints.4.title",
      descriptionKey: "solutions:fontany.ourFocusPoints.4.description",
    },
  ],
  sectionWithImage: null,
  section: [
    {
      titleKey: "solutions:fontany.section.0.title",
      descriptionKey: "solutions:fontany.section.0.description",
      sectionPointsKey: "solutions:fontany.section.0.sectionPoints",
    },
  ],
  solutionsForTopic: [
    {
      titleKey: "solutions:fontany.solutionsForTopic.title",
      descriptionKey: "solutions:fontany.solutionsForTopic.description",
      pointsKey: "solutions:fontany.solutionsForTopic.points",
    },
  ],
};
